import { FilterTestRow } from "./types";

export const INCLUDED_LABEL = "Included";
export const EXCLUDED_LABEL = "Excluded";

export const INCLUDED_OUTCOME_TOOLTIP =
  "This post matches your custom behavior rules, so it stays on the report. It will not be removed.";

export const EXCLUDED_OUTCOME_TOOLTIP =
  "This post does not match your custom behavior rules, so it is removed from the report.";

export function flagLabel(flag: number): string {
  if (flag === 1) return INCLUDED_LABEL;
  return EXCLUDED_LABEL;
}

export function flagTooltip(flag: number): string {
  if (flag === 1) return INCLUDED_OUTCOME_TOOLTIP;
  return EXCLUDED_OUTCOME_TOOLTIP;
}

export function buildFilteredReportText(rows: FilterTestRow[]): string {
  const included = rows.filter((row) => row.flag === 1);
  if (included.length === 0) {
    return `No posts remain after filtering. All sample posts were marked as ${EXCLUDED_LABEL}.`;
  }
  return included.map((row) => row.text).join("\n\n");
}
